/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { MessageRequestDto } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class MessageAdminController<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags message-admin-controller
   * @name Save
   * @request POST:/api/admin/v1/messages
   */
  save = (data: MessageRequestDto, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/admin/v1/messages`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags message-admin-controller
   * @name Delete
   * @request DELETE:/api/admin/v1/messages/{id}
   */
  delete = (id: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/api/admin/v1/messages/${id}`,
      method: "DELETE",
      ...params,
    });
}
